import React, { createContext, useCallback, useContext, useState } from 'react';

const OPEN_KEY = 'zeedcom-assistant-open';

interface AssistantDockState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

const AssistantDockContext = createContext<AssistantDockState | null>(null);

function readOpen(): boolean {
  try {
    return localStorage.getItem(OPEN_KEY) === '1';
  } catch {
    return false;
  }
}

function writeOpen(open: boolean) {
  try {
    localStorage.setItem(OPEN_KEY, open ? '1' : '0');
  } catch {
    // stockage indisponible
  }
}

export const AssistantDockProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpenState] = useState(readOpen);

  const setOpen = useCallback((next: boolean) => {
    setOpenState(next);
    writeOpen(next);
  }, []);

  const toggle = useCallback(() => {
    setOpenState((prev) => {
      const next = !prev;
      writeOpen(next);
      return next;
    });
  }, []);

  return (
    <AssistantDockContext.Provider value={{ open, setOpen, toggle }}>
      {children}
    </AssistantDockContext.Provider>
  );
};

export function useAssistantDock(): AssistantDockState {
  return useContext(AssistantDockContext) || {
    open: false,
    setOpen: () => {},
    toggle: () => {}
  };
}
